export const color = {
    emphasis: {
        NEUTRAL_N0: '#FFFFFF',
        NEUTRAL_N5: '#FBFBFB',
        NEUTRAL_N10: '#E2E2E2',
        NEUTRAL_N30: '#D5D5D5',
        NEUTRAL_N50: '#B9BABA',
        NEUTRAL_N70: '#828586',
        NEUTRAL_N90: '#45484A',
    },
    secondary: {
        CHARCOAL: '#333739',
        GREY_1: '#F8F8F8',
        GREY_4: '#C3C7CE',
        DARK_GREY: '#9A9A9A',
        LIGHT_GREY: '#F2F4FA',
        BORDER: '#D5D5D5',
    },
    primary: {
        BLUE_B90: '#1368BC',
        BLUE_B100: '#0058A0',
        BLUE_B200: '#0071C5',
        BLUE_B300: '#0091E6',
        RED: '#F00',
    },
    status: {
        SUCCESS: '#36B37E',
        SUCCESS_LIGHT: '#E7F8F1',
        FAIL: '#DA001A',
        DANGER_LIGHT: '#FFE6E0',
        WARNING: '#FFAB00',
        WARNING_LIGHT: '#FFF5E0',
        INFORMATION: '#2096D9',
        INFO_LIGHT: '#E4F3FB',
        WAREHOUSE: '#00838F',
        WAREHOUSE_LIGHT: '#E0F7FA',
    },
    button: {
        PRIMARY: '#0058A0',
        HOVER: '#61B4F3',
        PRESSED: '#013B6A',
        DISABLE: '#D8DDE2',
    },
};
